import * as request from "@/utils/request";
import { DefaultConfigs } from "@/common/js/constant";

const baseUrl = `${DefaultConfigs.publicAPIPath}`;

export type IStatement = {
  title: string;
  desc: string;
  content: IStatementItem[];
};

export type IStatementItem = {
  icon: string;
  content: string;
  link: string;
  //用于埋点上报
  name: string;
};

// 查询协议
export function queryStatement(): Promise<IStatement> {
  return request.post<IStatement>(`${baseUrl}/sofipo/v0/bill/choicePage`, {});
}
